import { render, staticRenderFns } from "./GalleryUploaderGrid.vue?vue&type=template&id=7ddbcc1a&scoped=true"
import script from "./GalleryUploaderGrid.vue?vue&type=script&lang=ts"
export * from "./GalleryUploaderGrid.vue?vue&type=script&lang=ts"
import style0 from "./GalleryUploaderGrid.vue?vue&type=style&index=0&id=7ddbcc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddbcc1a",
  null
  
)

export default component.exports